export default __webpack_public_path__ + "static/media/max.5a65f9ab.jpg";